import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 1,
  class: "mb-4"
};
import RouteService from '@/services/RouteService';
import MainHeader from '@/components/MainHeader.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import LlTextField from '@/components/LlTextField.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { storeToRefs } from 'pinia';
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import RateChangeConfirmationModal from '../company/CompanyUser/RateChangeConfirmationModal.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'UserRates',
  props: {
    rootScope: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const {
      getMe,
      updateMe
    } = meStore;
    const {
      me
    } = storeToRefs(meStore);
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const isSaving = ref(false);
    const unsaved = ref(false);
    const zeroRateAlert = ref(null);
    const myRatesForm = reactive({
      standard: null,
      other: []
    });
    const initialForm = reactive({});
    let routeService = null;
    let deactivateRouteChange = null;
    const myRatesState = reactive({
      loading: false,
      showRateChangeConfirmationModal: false,
      showZeroRateConfirmationModal: false,
      saveWithZeroRate: false
    });
    const somethingChanged = computed(() => {
      const originalStandard = me.value?.rates?.standard ?? '';
      const currentStandard = myRatesForm.standard ?? '';
      if (originalStandard !== currentStandard) return true;
      const originalRates = me.value?.rates?.other || [];
      const formRates = myRatesForm.other;
      if (formRates.length !== originalRates.length) return true;
      return formRates.some((rate, index) => {
        const originalRate = originalRates[index];
        if (!originalRate) return true;
        return rate.label !== originalRate.label || rate.amount !== originalRate.amount;
      });
    });
    const disableSave = computed(() => {
      return myRatesForm.standard === '' || myRatesForm.standard === null || myRatesForm.other.some(rate => rate.amount === '' || rate.amount === null);
    });
    const showZeroRateWarning = computed(() => {
      return myRatesForm.standard == 0 || myRatesForm.other.some(rate => rate.amount == 0);
    });
    const hasError = value => {
      return value === '' || value === null || value === undefined;
    };
    const resetForm = async () => {
      myRatesState.loading = true;
      await getMe();
      if (!me.value) return;
      const newForm = {
        standard: me.value?.rates?.standard ?? '',
        other: me.value?.rates?.other?.map(o => ({
          ...o,
          isNew: false
        })) || []
      };
      Object.assign(myRatesForm, newForm);
      Object.assign(initialForm, JSON.parse(JSON.stringify(newForm)));
      unsaved.value = false;
      myRatesState.loading = false;
    };
    const addNewRate = () => {
      myRatesForm.other.push({
        label: '',
        amount: '',
        isNew: true
      });
    };
    const removeRate = index => {
      myRatesForm.other.splice(index, 1);
    };
    const cancelChanges = () => {
      resetForm();
    };
    const triggerZeroRateConfirmation = () => {
      myRatesState.showZeroRateConfirmationModal = true;
      zeroRateAlert.value.open().then(result => {
        if (result) {
          myRatesState.showZeroRateConfirmationModal = false;
          myRatesState.saveWithZeroRate = true;
          myRatesState.showRateChangeConfirmationModal = true;
        } else {
          myRatesState.showZeroRateConfirmationModal = false;
        }
      });
    };
    const saveRates = async rateOptions => {
      isSaving.value = true;
      myRatesState.showRateChangeConfirmationModal = false;
      try {
        const payload = {
          rateOptions: {
            updateMatters: rateOptions.updateMatters,
            updateEntries: rateOptions.updateEntries
          },
          rates: {
            standard: myRatesForm.standard,
            other: myRatesForm.other?.map(({
              isNew,
              ...rate
            }) => rate)
          }
        };
        await updateMe(payload);
        handleSuccess('Your rates were successfully saved.');
        resetForm();
      } catch (err) {
        handleError(err);
      } finally {
        isSaving.value = false;
        unsaved.value = false;
        myRatesState.saveWithZeroRate = false;
      }
    };
    const saveChanges = async () => {
      if (showZeroRateWarning.value && !myRatesState.saveWithZeroRate) {
        triggerZeroRateConfirmation();
        return;
      }
      myRatesState.showRateChangeConfirmationModal = true;
    };
    onMounted(async () => {
      myRatesState.loading = true;
      resetForm();
      routeService = new RouteService(props);
      const onRouteChangeStart = event => {
        if (somethingChanged.value) {
          unsaved.value = true;
          setTimeout(() => {
            unsaved.value = false;
          }, 4000);
          event.preventDefault();
        }
      };

      // Register route change listener
      deactivateRouteChange = routeService.rootScopeChange().$on('$stateChangeStart', onRouteChangeStart);
    });
    onBeforeUnmount(() => {
      if (deactivateRouteChange) {
        deactivateRouteChange();
      }
    });
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_form = _resolveComponent("v-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: "My Rates"
      }), myRatesState.loading ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "p-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_col, {
          md: "3"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
            type: "list-item, list-item, list-item, list-item, list-item"
          })]),
          _: 1
        }), _createVNode(_component_v_col, {
          cols: "4"
        }), _createVNode(_component_v_col, {
          md: "3"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
            type: "list-item, list-item, list-item, list-item, list-item"
          })]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_dialog, {
        modelValue: myRatesState.showRateChangeConfirmationModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => myRatesState.showRateChangeConfirmationModal = $event),
        width: "400"
      }, {
        default: _withCtx(() => [_createVNode(RateChangeConfirmationModal, {
          onSave: saveRates,
          onCancel: _cache[0] || (_cache[0] = $event => myRatesState.showRateChangeConfirmationModal = false)
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
        showWarningIcon: true,
        ref_key: "zeroRateAlert",
        ref: zeroRateAlert,
        title: "",
        "confirm-text": "Save Anyway",
        "toggle-text": "Cancel",
        message: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`
      }, null, 512), _createVNode(_component_v_form, null, {
        default: _withCtx(() => [_createVNode(_component_v_row, {
          class: "form-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            cols: "3",
            md: "3"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
              class: "text-h6 font-weight-bold"
            }, "Label", -1)]))]),
            _: 1
          }), _createVNode(_component_v_col, {
            cols: "4"
          }), _createVNode(_component_v_col, {
            cols: "3",
            md: "3"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
              class: "text-h6 font-weight-bold"
            }, "Rate $", -1)]))]),
            _: 1
          }), _createVNode(_component_v_col, {
            cols: "2",
            md: "2"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" ", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_row, {
          class: "my-0 form-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            cols: "3"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
              class: "w-5/12 pr-4 leads-3"
            }, [_createElementVNode("label", {
              class: "text-left mb-5"
            }, "Standard Rate")], -1)]))]),
            _: 1
          }), _createVNode(_component_v_col, {
            cols: "4"
          }), _createVNode(_component_v_col, {
            cols: "3"
          }, {
            default: _withCtx(() => [_createVNode(LlTextField, {
              incomingName: 'rate',
              modelValue: myRatesForm.standard,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => myRatesForm.standard = $event),
              prefix: '$',
              type: "number",
              hideDetails: !hasError(myRatesForm.standard),
              placeholder: "amount",
              step: "any",
              rules: [v => !!v || `User's rate cannot be left blank`],
              label: ""
            }, null, 8, ["modelValue", "hideDetails", "rules"])]),
            _: 1
          }), _createVNode(_component_v_col, {
            cols: "2",
            md: "2"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" ", -1)]))]),
            _: 1
          })]),
          _: 1
        }), myRatesForm.other?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(myRatesForm.other, (rate, index) => {
          return _openBlock(), _createBlock(_component_v_row, {
            key: index,
            class: "my-0 align-center form-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_col, {
              cols: "3"
            }, {
              default: _withCtx(() => [rate.isNew ? (_openBlock(), _createBlock(LlTextField, {
                key: 0,
                incomingName: `label + ${index}`,
                modelValue: rate.label,
                "onUpdate:modelValue": $event => rate.label = $event,
                label: "",
                type: "text",
                placeholder: "Label",
                rules: [v => !!v || `Label is required`],
                hideDetails: !hasError(rate.label)
              }, null, 8, ["incomingName", "modelValue", "onUpdate:modelValue", "rules", "hideDetails"])) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(rate.label.toUpperCase()), 1))]),
              _: 2
            }, 1024), _createVNode(_component_v_col, {
              cols: "4"
            }), _createVNode(_component_v_col, {
              cols: "3"
            }, {
              default: _withCtx(() => [_createVNode(LlTextField, {
                incomingName: `amt + ${index}`,
                modelValue: rate.amount,
                "onUpdate:modelValue": $event => rate.amount = $event,
                prefix: '$',
                type: "number",
                hideDetails: !hasError(rate.amount),
                placeholder: "Amount",
                step: "any",
                rules: [v => v !== '' && v !== null && v !== undefined || `User's rate cannot be left blank`],
                label: ""
              }, null, 8, ["incomingName", "modelValue", "onUpdate:modelValue", "hideDetails", "rules"])]),
              _: 2
            }, 1024), _createVNode(_component_v_col, {
              cols: "2",
              class: "cursor-pointer"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_icon, {
                class: "hover:text-[red]",
                onClick: $event => removeRate(index)
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("mdi-close-circle-outline", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128)) : _createCommentVNode("", true), _createVNode(_component_v_row, {
          class: "ps-2"
        }, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => addNewRate(), ["prevent"])),
            disabled: disableSave.value
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Add Non-Standard Rate ", -1)]))]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(SettingsSaveBar, {
          somethingChanged: somethingChanged.value,
          saving: isSaving.value,
          unsaved: unsaved.value,
          onUpdate: saveChanges,
          onCancel: cancelChanges,
          disabled: disableSave.value
        }, null, 8, ["somethingChanged", "saving", "unsaved", "disabled"])]),
        _: 1
      })]))]);
    };
  }
};